// Reducer handlers
const reducerHandlers = {
  ['SET_TRUSTPILOT'](state, { payload }) {
    return {
      ...state,
      ...payload
    };
  }
};

export default reducerHandlers;
